<template lang="pug">
  section.headerWrapper
    header#header.fluid
      router-link(to="/")#logo.left
        LogoIcon.icon
        LogoText.text
        h1 Cubo Maia | Design e Tecnologia
      Nav(:navSocial="navSocial")
    Cover(v-if="cover", :title="cover.title", :subtitle="cover.subtitle", :nav="cover.nav")
</template>

<script>
import './style.sass'
import LogoIcon from '@/assets/svg/logo/icon.svg';
import LogoText from '@/assets/svg/logo/text.svg';
import Nav from '@/components/Nav/index.vue'
import Cover from '@/components/Cover/index.vue'

export default {
  name: 'Header',
  props: {
    cover: Object,
    navSocial: Array
  },
  components: {
    Nav,
    Cover,
    LogoIcon,
    LogoText
  },
}
</script>